import { toDisplayString as _toDisplayString, createElementVNode as _createElementVNode, createTextVNode as _createTextVNode, resolveComponent as _resolveComponent, withCtx as _withCtx, createVNode as _createVNode, openBlock as _openBlock, createElementBlock as _createElementBlock, createCommentVNode as _createCommentVNode, withModifiers as _withModifiers } from "vue"

const _hoisted_1 = {
  "data-testid": "step-Login",
  class: "container"
}
const _hoisted_2 = { class: "container__main-header" }
const _hoisted_3 = { class: "container__main-paragraph" }
const _hoisted_4 = { key: 0 }
const _hoisted_5 = {
  key: 0,
  class: "container__mention"
}
const _hoisted_6 = {
  key: 1,
  class: "container__mention"
}
const _hoisted_7 = ["onSubmit"]
const _hoisted_8 = { class: "row" }
const _hoisted_9 = { class: "row" }
const _hoisted_10 = { class: "row row--remind-password" }
const _hoisted_11 = ["href"]

export function render(_ctx: any,_cache: any,$props: any,$setup: any,$data: any,$options: any) {
  const _component_router_link = _resolveComponent("router-link")!
  const _component_Field = _resolveComponent("Field")!
  const _component_SubmitButton = _resolveComponent("SubmitButton")!

  return (_openBlock(), _createElementBlock("div", _hoisted_1, [
    _createElementVNode("h1", _hoisted_2, _toDisplayString(_ctx.$t(`${_ctx.TRANSLATION_KEY}.logInAccount`)), 1),
    _createElementVNode("div", _hoisted_3, [
      _createElementVNode("span", null, _toDisplayString(_ctx.$t(`${_ctx.TRANSLATION_KEY}.or`)), 1),
      _createVNode(_component_router_link, {
        to: "/",
        onClick: _cache[0] || (_cache[0] = () => _ctx.handleClick())
      }, {
        default: _withCtx(() => [
          _createTextVNode(_toDisplayString(_ctx.$t(`${_ctx.TRANSLATION_KEY}.createNewAccount`)), 1)
        ]),
        _: 1
      })
    ]),
    (_ctx.isEmail && !_ctx.isClicked)
      ? (_openBlock(), _createElementBlock("div", _hoisted_4, [
          (_ctx.messageInfo)
            ? (_openBlock(), _createElementBlock("div", _hoisted_5, _toDisplayString(_ctx.messageInfo), 1))
            : (_openBlock(), _createElementBlock("div", _hoisted_6, _toDisplayString(_ctx.$t(`${_ctx.TRANSLATION_KEY}.yourAccountIsExist`)), 1))
        ]))
      : _createCommentVNode("", true),
    _createElementVNode("form", {
      autocomplete: "off",
      onSubmit: _withModifiers(($event: any) => (null), ["prevent"])
    }, [
      _createElementVNode("div", _hoisted_8, [
        _createVNode(_component_Field, {
          modelValue: _ctx.formData.loginEmail,
          "onUpdate:modelValue": _cache[1] || (_cache[1] = ($event: any) => (_ctx.formData.loginEmail = $event)),
          type: "email",
          name: "loginEmail",
          placeholder: _ctx.$t(`${_ctx.TRANSLATION_KEY}.emailPlaceholder`),
          "cy-data": "login-email",
          "allow-all-characters": true
        }, {
          default: _withCtx(() => [
            _createElementVNode("span", null, _toDisplayString(_ctx.$t(`${_ctx.TRANSLATION_KEY}.email`)), 1)
          ]),
          _: 1
        }, 8, ["modelValue", "placeholder"])
      ]),
      _createElementVNode("div", _hoisted_9, [
        _createVNode(_component_Field, {
          modelValue: _ctx.formData.loginPassword,
          "onUpdate:modelValue": _cache[2] || (_cache[2] = ($event: any) => (_ctx.formData.loginPassword = $event)),
          type: "password",
          name: "loginPassword",
          placeholder: _ctx.$t(`${_ctx.TRANSLATION_KEY}.existingPassword`),
          "cy-data": "login-password",
          "allow-all-characters": true
        }, {
          default: _withCtx(() => [
            _createElementVNode("span", null, _toDisplayString(_ctx.$t(`${_ctx.TRANSLATION_KEY}.password`)), 1)
          ]),
          _: 1
        }, 8, ["modelValue", "placeholder"])
      ]),
      _createElementVNode("div", _hoisted_10, [
        _createElementVNode("a", {
          href: _ctx.$t(`${_ctx.TRANSLATION_KEY}.remindPasswordLink`),
          "cy-data": "remind-password"
        }, _toDisplayString(_ctx.$t(`${_ctx.TRANSLATION_KEY}.remindPassword`) + ' \xbb'), 9, _hoisted_11)
      ]),
      _createVNode(_component_SubmitButton, {
        action: _ctx.Action.LOGIN,
        "button-value": _ctx.$t(`${_ctx.TRANSLATION_KEY}.logIn`),
        data: _ctx.formData,
        "data-testid": "btn-Login-submit",
        class: "button button--submit",
        disabled: !(_ctx.formData.loginEmail && _ctx.formData.loginPassword),
        onClick: _ctx.login
      }, null, 8, ["action", "button-value", "data", "disabled", "onClick"])
    ], 40, _hoisted_7)
  ]))
}